import React, { createContext, useState, useEffect } from 'react'
import http from '../http'

const CatalogContext = createContext()

function Catalog( props ) {
  const [ catalog, setCatalog ] = useState( {
    cards: [],
    filters: [],
    exportButtons: [],
    aside: []
  } )

  const [ cards, setCards ] = useState(
    JSON.parse( localStorage.getItem( 'cards' ) || '[]' )
  )

  const updateCards = ( value ) => {
    const encodedValue = JSON.stringify( value )
    setCards( value )
    localStorage.setItem( 'cards', encodedValue )
  }

  useEffect( () => {
    if ( catalog.cards.length !== 0 ) return

    async function fetchData() {
      const [
        _cards,
        filters,
        exportButtons,
        aside
      ] = [
        await http.get( '/api/collection/cards/all' ),
        await http.get( '/api/collection/filters/all' ),
        await http.get( '/api/collection/exportButtons/all' ),
        await http.get( '/api/collection/aside/all' )
      ].map( response => response.data )

      if ( cards.length === 0 )
        updateCards( _cards )

      setCatalog( {
        cards: _cards,
        filters,
        exportButtons,
        aside
      } )
    }

    fetchData()
  }, [ catalog ] )

  if ( catalog.cards.length === 0 )
    return null

  return (
    <CatalogContext.Provider
      value={ {
        catalog,
        cards,
        updateCards
      } }
    >
      { props.children }
    </CatalogContext.Provider>
  )
}

const withCatalog = ( ComponentAlias ) => {
  return props => (
    <CatalogContext.Consumer>
      { context => <ComponentAlias { ...props } withCatalog={ context } /> }
    </CatalogContext.Consumer>
  )
}

export {
  withCatalog,
  CatalogContext
}

export default Catalog
